import { useRef } from 'react'

// Browsers can dispatch a click on the common ancestor when a pointer press starts
// inside a dialog and is released on its backdrop.  A modal may therefore dismiss only
// when the same primary-pointer gesture both starts and ends on the backdrop itself.
export function useDeliberateBackdropDismiss(onClose) {
  const armedPointer = useRef(null)

  return {
    onPointerDown: e => {
      armedPointer.current = e.isPrimary && e.button === 0 && e.target === e.currentTarget
        ? e.pointerId
        : null
    },
    onPointerUp: e => {
      const dismiss = armedPointer.current === e.pointerId && e.target === e.currentTarget
      armedPointer.current = null
      if (dismiss) onClose?.()
    },
    onPointerCancel: () => { armedPointer.current = null },
  }
}
